import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {fetchBaseFPNetQuery} from "../../../utils/fetchBaseFPNetQuery";
import {addURI, transformResponse} from "@commons/utils/APIParams";
import {ElementoRMLSelezionabileRecord} from "@commons/mapping/ElementoRMLSelezionabileRecord";
import {CDate} from "@commons/types";
import {config} from "@commons/config.instance";

export interface Params {
    idAziendaMaster: number | null,
    idAzienda: number | null,
    dataDa: CDate,
    dataA: CDate,
}

export const ElementoRMLXSelezioneByAziendaApi = createApi({
    reducerPath: 'ElementiRMLXSelezioneByAziendaApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('HR')}),
    endpoints: (builder) => ({

        getElementiXSelezione: builder.query<ElementoRMLSelezionabileRecord[], Params>({
            query: ({idAziendaMaster, idAzienda, dataDa, dataA}) => {
                let params: string[] = [];
                params.push(`dataDa=${dataDa}`);
                params.push(`dataA=${dataA}`);

                return `/PVA/setup-elementi-RML/azienda/${idAziendaMaster}-${idAzienda}?${params.length > 0 ? '&' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse: addURI
        }),
        update: builder.mutation<Partial<ElementoRMLSelezionabileRecord>, Partial<ElementoRMLSelezionabileRecord> & Pick<ElementoRMLSelezionabileRecord, 'URI'>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({URI, ...patch}) => ({
                url: URI ? URI : '',
                method: 'PATCH',
                body: patch,
            }),
            transformResponse,
            //invalidatesTags: (result, error, {URI}) => [{type: 'Lavoratori', URI}],
        }),
    }),
})
export const {
    useGetElementiXSelezioneQuery,
    useLazyGetElementiXSelezioneQuery,
    useUpdateMutation,
} = ElementoRMLXSelezioneByAziendaApi;